import gql from 'graphql-tag'

export const GET_EMPLOYEES = gql`
  query($filter: Filter) {
    employees(filter: $filter) {
      id
      status
      state
      tags
      groups
      partners
      user {
        id
        username
        roles
        avatar
        email
        state
        details {
          firstName
          lastName
          nationalId
          birthday
          gender
        }
      }
    }
  }
`

export const GET_EMPLOYEE = gql`
  query($id: String!) {
    employee(id: $id) {
      id
      status
      state
      tags
      groups
      partners
      user {
        id
        username
        roles
        avatar
        email
        state
        details {
          firstName
          lastName
          nationalId
          birthday
          gender
        }
      }
    }
  }
`
